/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WebsiteLogoQueryVariables = GraphQL.Exact<{
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type WebsiteLogoQuery = { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly logo: string | null } | null };


export const WebsiteLogoDocument = gql`
    query WebsiteLogo($websiteId: WebsiteId!) {
  website(id: $websiteId) {
    id
    logo
  }
}
    `;

/**
 * __useWebsiteLogoQuery__
 *
 * To run a query within a React component, call `useWebsiteLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteLogoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteLogoQuery({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useWebsiteLogoQuery(baseOptions: Apollo.QueryHookOptions<WebsiteLogoQuery, WebsiteLogoQueryVariables> & ({ variables: WebsiteLogoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteLogoQuery, WebsiteLogoQueryVariables>(WebsiteLogoDocument, options);
      }
export function useWebsiteLogoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteLogoQuery, WebsiteLogoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteLogoQuery, WebsiteLogoQueryVariables>(WebsiteLogoDocument, options);
        }
export function useWebsiteLogoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteLogoQuery, WebsiteLogoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteLogoQuery, WebsiteLogoQueryVariables>(WebsiteLogoDocument, options);
        }
export type WebsiteLogoQueryHookResult = ReturnType<typeof useWebsiteLogoQuery>;
export type WebsiteLogoLazyQueryHookResult = ReturnType<typeof useWebsiteLogoLazyQuery>;
export type WebsiteLogoSuspenseQueryHookResult = ReturnType<typeof useWebsiteLogoSuspenseQuery>;
export type WebsiteLogoQueryResult = Apollo.QueryResult<WebsiteLogoQuery, WebsiteLogoQueryVariables>;